<template>
    <div>
        <div
            v-if="redemptions.length > 0"
            class="flex items-center justify-between mb-2"
        >
            <h4 class="font-medium">Details</h4>
            <h4 class="font-medium">Points/Cash Used</h4>
        </div>
        <div v-for="redemption in redemptions" :key="redemption.id">
            <div class="flex items-center justify-between py-4">
                <div class="flex items-center gap-4">
                    <div
                        class="w-14 h-14 rounded-full flex items-center text-orange-600 justify-center bg-orange-100"
                    >
                        <RedemptionIcon
                            :redemption="redemption"
                            class="w-6 h-6"
                        />
                    </div>
                    <div>
                        <p class="text-slate-600 font-semibold mb-1">
                            {{ redemption.name }}
                        </p>
                        <p class="text-slate-500 text-sm lg:text-base">
                            {{ startDate(redemption) }}
                            <span v-if="redemption.end_date">
                                -
                                {{ endDate(redemption) }}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="flex flex-col justify-start">
                    <p class="text-gray-600 text-sm text-right">
                        {{ pointsUsed(redemption) }}
                    </p>
                    <p
                        v-if="
                            redemption.payment_program &&
                            redemption.payment_program.program_image
                        "
                        class="mt-1"
                    >
                        <img
                            :src="
                                cdnUrl +
                                '/' +
                                redemption.payment_program.program_image.path +
                                '/_small/' +
                                redemption.payment_program.program_image
                                    .file_name
                            "
                            :alt="redemption.payment_program.name"
                            class="w-16 h-auto ml-auto"
                        />
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue';
import RedemptionIcon from '@/components/trips/redemptions/redemption-icon.vue';
import dayjs from 'dayjs';
const { redemptions, userTrip } = defineProps(['redemptions', 'userTrip']);

const cdnUrl = computed(() => {
    return window.cdnUrl;
});

const pointsUsed = (redemption) => {
    let cashAmount =
        '$' +
        new Intl.NumberFormat({
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(
            parseFloat(redemption.payment_cash_amount) +
                parseFloat(redemption.payment_taxes_fees ?? 0)
        );

    let pointsAmount = new Intl.NumberFormat().format(
        redemption.payment_points ?? 0
    );

    switch (redemption.payment_type) {
        case 'points':
            return pointsAmount;
        case 'cash':
            return cashAmount;
        case 'cash_points':
            return pointsAmount + ' / ' + cashAmount;
    }
    return 0;
};

const startDate = (redemption) => {
    let newDate = userTrip ? userTrip?.start_date : redemption.start_date;
    let newStartDate = userTrip ? userTrip?.end_date : redemption.end_date;
    if (
        redemption.date_type === 'end' &&
        redemption.redemption_type.slug === 'flight'
    ) {
        return dayjs(newStartDate).format('MMM DD, YYYY');
    }

    if (
        redemption.date_type === 'start' &&
        redemption.redemption_type.slug === 'hotel'
    ) {
        return dayjs(newDate).format('MMM DD, YYYY');
    }

    return dayjs(newDate).format('MMM DD, YYYY');
};

const endDate = (redemption) => {
    let newDate = userTrip ? userTrip?.end_date : redemption.end_date;
    let newStartDate = userTrip ? userTrip?.start_date : redemption.start_date;
    if (
        redemption.date_type === 'start' &&
        redemption.redemption_type.slug === 'flight'
    ) {
        return dayjs(newStartDate).format('MMM DD, YYYY');
    }
    return dayjs(newDate).format('MMM DD, YYYY');
};
</script>
